<template>
	<div class="user box" id="rightCont">
		<div class="title">
			<span style="color: #3f3f3f;font-size: 18px;font-weight: bold;">{{ nameTitle }}</span>
		</div>
		<div class="main">
			<div class="main-right" ref="mainRight">
				<div class="searchValue">
					<el-autocomplete :fetch-suggestions="querySearch" placeholder="请输入用户名称" :trigger-on-focus="false"
						size="mini" @select="handleSelect" v-model="searchValue" clearable>
						<i slot="prefix" class="el-input__icon el-icon-Ssearch"></i>
					</el-autocomplete>

					<el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon"
						size="mini" @click="handClick(i)">{{ v.title }}</el-button>
				</div>
				<!-- btn3 -->
				<div class="btnBottom">
					<!-- feet -->
					<div class="feet" id="feet">
						<el-button v-for="(v,i) in feetBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon"
							size="mini" @click="feetHandClick(v,i)">{{ v.title }}</el-button>
					</div>
					<div class="b">
						<el-button v-for="(v,i) in headerBtnbottomRight" :key="i" :type="v.type" :loading="loading"
							:icon="v.icon" size="mini" @click="headerBtnbottomRightClick(i)">
							<span v-if="v.title">{{ v.title }}</span>
						</el-button>
					</div>
				</div>
				<div class="content">
					<el-table :data="tableData" :header-cell-style="{ background: '#f4f4f4 !important'}" border
						highlight-current-row @current-change="handleCurrentTableChange" @row-dblclick="handledbRow"
						:style="{ width: windowWidth + 'px' }" v-loading="loading"
						element-loading-spinner="el-icon-more-outline">
						<el-table-column v-for="(col, inx) in tableRows" :key="inx" border='false' :type="col.type"
							:prop="col.prop" :label="col.name" :width="columnWidth(col, tableData)"></el-table-column>
						<!-- fixed -->
						<el-table-column fixed="left" label="序号" type="index"></el-table-column>
						<el-table-column prop="status" label="状态" width="120" align="center">
							<template slot-scope="{ row }">
								<el-button :loading="loading" size="mini" plain :disabled="true"
									:type="row.status === '1' ? 'danger' : 'success'" @click="toggleStatus(row)">
									{{ row.status === '1' ? '去禁用' : '去启用' }}
								</el-button>
							</template>
						</el-table-column>
						<!-- edit -->
						<el-table-column fixed="right" label="操作" width="180">
							<template slot-scope="scope">
								<div class="editbox" style="display: flex; justify-content: center; align-items: center;">
									<!-- 修改按钮：权限控制（disabled + tooltip） -->
									<el-tooltip
										:content="$store.getters.hasPermission('system:user:edit') ? '' : '您当前暂无此操作权限，请联系商务或管理员！'"
										placement="top"
										:disabled="$store.getters.hasPermission('system:user:edit')">
										<el-button
											type="text"
											size="mini"
											:disabled="!$store.getters.hasPermission('system:user:edit')"
											@click="handleClickEdit(scope.row)">
											修改
										</el-button>
									</el-tooltip>

									<!-- 冻结按钮（无权限控制，始终可用） -->
									<!-- <el-button type="text" size="mini" @click="handleUserSuspendAccount(scope.row)">冻结</el-button> -->

									<!-- 重置密码按钮：权限控制（disabled + tooltip） -->
									<el-tooltip
										:content="$store.getters.hasPermission('system:user:editPwd') ? '' : '您当前暂无此操作权限，请联系商务或管理员！'"
										placement="top"
										:disabled="$store.getters.hasPermission('system:user:editPwd')">
										<el-button
											type="text"
											size="mini"
											:disabled="!$store.getters.hasPermission('system:user:editPwd')"
											@click="HandleCommand(scope.row)">
											重置密码
										</el-button>
									</el-tooltip>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- 分页 -->
				<el-pagination style="margin: 12px;" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[15, 50, 100]"
					:page-size="pageSize" :total="totalSize" layout="total, sizes, prev, pager, next, jumper"
					background>
				</el-pagination>
			</div>
		</div>
		<!-- 新增Model -->
		<div class="addModel">
			<el-dialog title="新增系统用户" :visible.sync="addModelDialogVisible" width="48%" :before-close="handleClose"
				@opened="onAddDialogOpened">
				<!-- 新增主体 -->
				<div class="content">
					<el-form ref="addForm" :model="addForm" :rules="rules" label-width="88px" size="mini"
						style="display: flex;flex-wrap: wrap;">
						<el-form-item label="账户名" prop="username">
							<el-input v-model="addForm.username"></el-input>
						</el-form-item>
						<el-form-item label="登录密码" prop="password">
							<el-input v-model="addForm.password" show-password @input="PwdRules"
								:disabled="PWDdisabled"></el-input>
						</el-form-item>
						<!-- ★ 角色：el-tree 树形控件（一级多选），node-key 直接绑定后端 string id -->
						<el-form-item label="角色Id" prop="roleId">
							<div class="role-tree-wrapper">
								<el-tree ref="addRoleTree" :data="roleoptions" :props="roleTreeProps" node-key="id"
									show-checkbox :default-expand-all="true" :check-strictly="true"
									:expand-on-click-node="false" @check="handleAddRoleTreeCheck" class="role-tree"
									empty-text="暂无角色">
								</el-tree>
							</div>
						</el-form-item>
						<el-form-item label="员工姓名" prop="staffName">
							<el-select v-model="addForm.staffName" placeholder="请选择" @focus="chooseStaff"
								@change="choosedRole" filterable popper-class="fixed-header-select">
								<!-- 选项组 -->
								<el-group>
									<!-- 固定头部 -->
									<div class="select-header" slot="header" style="font-size: 12px;font-weight: bold;display: flex;justify-content: space-around;padding: 12px;background-color: #f1f1f1;
										position: sticky;top:0;z-index: 10;">
										<span>编码</span>
										<span>姓名</span>
										<span>科室部门</span>
									</div>

									<!-- 选项内容 -->
									<el-option v-for="item in Useroptions" :key="item.id" :label="item.label"
										:value="item.id" class="select-option">
										<div class="option-content">
											<span style="font-size: 12px;margin-left:8px;">{{ item.userCode }}</span>
											<span style="font-size: 12px;margin-left:8px;">{{ item.label }}</span>
											<span style="font-size: 12px;margin-left:8px;">{{ item.deptName }}</span>
										</div>
									</el-option>
								</el-group>
							</el-select>
						</el-form-item>
						<el-form-item label="员工Id" prop="staffId">
							<el-input v-model="addForm.staffId" :disabled="disabled"></el-input>
						</el-form-item>
						<el-form-item label="邮箱" prop="email">
							<el-input v-model="addForm.email"></el-input>
						</el-form-item>
						<el-form-item label="诊所ID" prop="clinicId">
							<el-select v-model="addForm.clinicId" placeholder="请选择" @focus="chooseclinicId">
								<el-option v-for="item in clinicIdoptions" :key="item.label" :label="item.label"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="状态" prop="status">
							<el-switch v-model="addForm.status" active-value="1" active-color="#13ce66"
								inactive-value="0" inactive-color="#ff4949">
							</el-switch>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" type="primary" @click="submitForm">添加</el-button>
					<el-button size="mini" @click="addModelDialogVisible = false;">取消</el-button>
				</span>
			</el-dialog>
		</div>
		<!-- 编辑Model -->
		<div class="editModel">
			<el-dialog title="修改用户" :visible.sync="editModelDialogVisible" width="48%" :before-close="handleClose"
				@opened="onEditDialogOpened">
				<!-- 修改主体 -->
				<div class="editcontent">
					<el-form ref="editForm" :model="editForm" :rules="rules" label-width="88px" size="mini"
						style="display: flex;flex-wrap: wrap;">

						<!-- 账户名 -->
						<el-form-item label="账户名" prop="username">
							<el-input v-model="editForm.username"></el-input>
						</el-form-item>

						<!-- 账户ID -->
						<el-form-item label="账户ID" prop="userId">
							<el-input v-model="editForm.userId" :disabled="disabled"></el-input>
						</el-form-item>

						<!-- 所属诊所 -->
						<el-form-item label="所属诊所" prop="clinicName">
							<el-input v-model="editForm.clinicName" :disabled="true"></el-input>
						</el-form-item>

						<!-- 员工姓名 -->
						<el-form-item label="员工姓名" prop="staffName">
							<el-input v-model="editForm.staffName" :disabled="true"></el-input>
						</el-form-item>

						<!-- 员工ID -->
						<el-form-item label="员工ID" prop="staffId">
							<el-input v-model="editForm.staffId" :disabled="true"></el-input>
						</el-form-item>

						<!-- 邮箱 -->
						<el-form-item label="邮箱" prop="email">
							<el-input v-model="editForm.email"></el-input>
						</el-form-item>

						<!-- ★ 角色：el-tree 树形控件（一级多选），node-key 直接绑定后端 string id -->
						<el-form-item label="角色" prop="roleId">
							<div class="role-tree-wrapper">
								<el-tree ref="editRoleTree" :data="roleoptions" :props="roleTreeProps" node-key="id"
									show-checkbox :default-expand-all="true" :check-strictly="true"
									:expand-on-click-node="false" @check="handleEditRoleTreeCheck" class="role-tree"
									empty-text="暂无角色">
								</el-tree>
							</div>
						</el-form-item>

						<!-- 用户状态 -->
						<el-form-item label="用户状态" prop="status">
							<el-switch v-model="editForm.status" active-value="1" active-color="#13ce66"
								inactive-value="0" inactive-color="#ff4949">
							</el-switch>
						</el-form-item>

					</el-form>
				</div>

				<span slot="footer" class="dialog-footer">
					<el-button size="mini" type="primary" @click="editSubmit">确定</el-button>
					<el-button size="mini" @click="editModelDialogVisible = false">取消</el-button>
				</span>
			</el-dialog>
		</div>
		<!-- 查看dialog -->
		<el-dialog title="用户详情" :visible.sync="detailDialogVisible" width="50%" :before-close="handleClose">
			<el-descriptions :column="2" border>
				<el-descriptions-item label="账户名">{{ detailData.username }}</el-descriptions-item>
				<el-descriptions-item label="用户ID">{{ detailData.userId }}</el-descriptions-item>
				<el-descriptions-item label="状态">
					<el-tag :type="detailData.status === '1' ? 'success' : 'danger'" size="small">
						{{ detailData.status === '1' ? '可用' : '锁定' }}
					</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="手机号">{{ detailData.tel }}</el-descriptions-item>
				<el-descriptions-item label="邮箱">{{ detailData.email }}</el-descriptions-item>
				<el-descriptions-item label="创建时间">{{ detailData.createTime }}</el-descriptions-item>
				<el-descriptions-item label="所属诊所">{{ detailData.clinicName }}</el-descriptions-item>
			</el-descriptions>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="detailDialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>
		<!-- 重置密码dialog -->
		<div class="resetPwd">
			<el-dialog title="重置密码" :visible.sync="resetPwddialogVisible" width="20%" :before-close="handleClose">
				<div v-if="this.Self === true" style="padding: 12px;text-align: center;">
					<span>当前用户：<i class="el-icon-aim"></i>{{ userName + '（我）' }}</span>
				</div>
				<div v-else style="padding: 12px;text-align: center;">
					<span>当前用户：{{ userName }}</span>
				</div>
				<el-form ref="resetPwdForm" :model="resetPwdForm" :rules="rules" label-width="88px" size="mini"
					style="display: flex;flex-wrap: wrap;">
					<el-form-item label="原始密码" prop="oldPassword" v-if="!Self">
						<el-input show-password v-model="resetPwdForm.oldPassword"></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="newPassword">
						<el-input show-password v-model="resetPwdForm.newPassword"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="xtRest">系统重置</el-button>
					<el-button size="mini" @click="resetPwddialogVisible = false">取 消</el-button>
					<el-button size="mini" type="primary" @click="resetPwdSubmit">确 定</el-button>
				</span>
			</el-dialog>
		</div>
		<!-- 用户查询 -->
		<el-dialog title="用户查询" :visible.sync="searchDialogVisible" width="50%" top="18px" :before-close="handleClose">
			<el-form :model="userForm" label-width="120px" label-position="left">
				<div style="display: flex;">
					<!-- 左侧表单区域 -->
					<div style="flex: 1; padding-right: 20px;font-size: 12px;">
						<el-form-item label="用户编码">
							<el-input v-model="userForm.username" placeholder="请输入用户名"></el-input>
						</el-form-item>

						<el-form-item label="用户昵称">
							<el-input v-model="userForm.staffName" placeholder="用户昵称"></el-input>
						</el-form-item>

						<el-form-item label="UID">
							<el-input v-model="userForm.uid" disabled></el-input>
						</el-form-item>

						<el-form-item label="用户角色UID">
							<el-input v-model="userForm.staffId">
							</el-input>
						</el-form-item>

						<el-form-item label="国家">
							<el-select v-model="userForm.country" placeholder="请选择">
								<el-option label="中国" value="CN"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="手机(选填)">
							<el-input v-model="userForm.phone"></el-input>
						</el-form-item>

						<el-form-item label="Email(选填)">
							<el-input v-model="userForm.email"></el-input>
						</el-form-item>

						<el-checkbox disabled v-model="userForm.mustChangePassword">用户首次登录必须更改密码</el-checkbox>
						<el-checkbox disabled v-model="userForm.sendNotification">发送一封通知邮件给新增用户(编辑信息)</el-checkbox>
					</div>

					<!-- 右侧权限区域 -->
					<div style="flex: 1; border-left: 1px solid #eee; padding-left: 20px;">
						<el-form-item label="用户诊所ID">
							<el-tag>{{ this.clinicId }}</el-tag>
						</el-form-item>

						<el-form-item label="共享文件夹权限">
							<div>
								<div>用户权限</div>
								<div>读取/写入: Multimedia, 照片</div>
							</div>
						</el-form-item>
					</div>
				</div>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="searchDialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAllUser,
		roleList,
		GetUserInfo,
		addUser,
		updateUser,
		getuserInfo,
		editPwd,
		userSuspendAccount
	} from "@/api/user.js";
	import {
		selectList,
		yglist
	} from "@/api/staff/staff.js";
	import {
		doccliniclist
	} from "@/api/cinic/cinic.js";
	import {
		docclinic
	} from "@/api/cinic/cinic.js";

	export default {
		components: {},
		data() {
			return {
				userName: '',
				nameTitle: '系统用户管理',
				filterText: '',
				searchValue: '',
				searchTreeValue: '',
				selectValue: '',
				windowWidth: '',
				loading: false,
				Self: false,
				disabled: true,
				PWDdisabled: true,
				detailDialogVisible: false,
				searchDialogVisible: false,
				detailData: {},
				addModelDialogVisible: false,
				editModelDialogVisible: false,
				resetPwddialogVisible: false,
				tableWidth: '',
				stepsStatus: '',
				finishStatus: '',
				clinicId: '',
				stepsActive: 0,
				pageNum: 1,
				pageSize: 15,
				totalSize: 10,
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				userForm: {
					username: '九阵666',
					staffName: '',
					password: '',
					confirmPassword: '',
					country: 'CN',
					phone: '',
					email: '',
					uid: '',
					mustChangePassword: true,
					sendNotification: false
				},
				elTree: [{
					label: '宜宾九阵软件科技有限公司',
					path: '',
					title: '',
					icon: 'el-icon-news',
					children: [{
							label: '运维部',
							path: '',
							title: '',
							icon: 'el-icon-news',
							children: [{
									label: '运维一组',
									path: '',
									title: '',
									icon: 'el-icon-news',
								},
								{
									label: '运维二组',
									path: '',
									title: '',
									icon: 'el-icon-news',
								},
								{
									label: '运维三组',
									path: '',
									title: '',
									icon: 'el-icon-news',
								},
							]
						},
						{
							label: '后勤部',
							path: '',
							title: '',
							icon: 'el-icon-news',
							children: [{
									label: '后勤一部',
									path: '',
									title: '',
									icon: 'el-icon-news',
								},
								{
									label: '后勤二部',
									path: '',
									title: '',
									icon: 'el-icon-news',
								}
							]
						},
						{
							label: '财务部',
							path: '',
							title: '',
							icon: 'el-icon-news',
							children: [{
									label: '宜宾一部',
									path: '',
									title: '',
									icon: 'el-icon-news',
								},
								{
									label: '成都二部',
									path: '',
									title: '',
									icon: 'el-icon-news',
								},
								{
									label: '水富三部',
									path: '',
									title: '',
									icon: 'el-icon-news',
								}
							]
						},
						{
							label: '研发部',
							path: '',
							title: '',
							icon: 'el-icon-news',
							children: [{
									label: '后端',
									path: '',
									title: '',
									icon: 'el-icon-news',
									children: [{
											label: '后端一组',
											path: '',
											title: '',
											icon: 'el-icon-news',
										},
										{
											label: '后端二组',
											path: '',
											title: '',
											icon: 'el-icon-news',
										}
									]
								},
								{
									label: '前端',
									path: '',
									title: '',
									icon: 'el-icon-news',
									children: [{
											label: '前端一组',
											path: '',
											title: '',
											icon: 'el-icon-news',
										},
										{
											label: '前端二组',
											path: '',
											title: '',
											icon: 'el-icon-news',
										}
									]
								},
								{
									label: '设计',
									path: '',
									title: '',
									icon: 'el-icon-news',
									children: [{
											label: 'UI一部',
											path: '',
											title: '',
											icon: 'el-icon-news',
										},
										{
											label: '平面二部',
											path: '',
											title: '',
											icon: 'el-icon-news',
										}
									]
								},
							]
						}
					],
				}],
				Useroptions: [],
				roleoptions: [],
				clinicIdoptions: [],
				docclinicOptions: [],
				options: [{
					value: '1',
					label: '可用'
				}, {
					value: '0',
					label: '锁定'
				}],
				defaultButtons: [{
						title: "查看",
						icon: "el-icon-watch",
						type: "primary"
					},
					{
						title: "打印",
						icon: "el-icon-ggml",
						type: "primary"
					},
					{
						title: "导出",
						icon: "el-icon-export",
						type: "primary"
					},
					{
						title: "关闭",
						icon: "el-icon-close",
						type: "primary"
					},
				],
				feetBtn: [{
						label: "导入",
						icon: "el-icon-upload2"
					},
					{
						label: "关闭",
						types: "primary",
						icon: "el-icon-close"
					},
				],
				roleLoading: false,
				headerBtn: [{
					title: "查询",
					icon: "el-icon-Ssearch"
				}],
				headerBtnbottomRight: [{
					title: "导出",
					icon: "el-icon-download"
				}, {
					icon: "el-icon-refresh"
				}, {
					icon: "el-icon-s-tools"
				}, {
					icon: "el-icon-full-screen"
				}],
				tableRows: [{
						name: "账户名",
						prop: "username",
						type: ""
					}, {
						name: "当前系统",
						prop: "clinicName",
						type: ""
					},
					{
						name: "用户ID",
						prop: "userId",
						type: ""
					}, {
						name: "手机号",
						prop: "tel",
						type: ""
					},
					{
						name: "邮箱",
						prop: "email",
						nz: "nz"
					}, {
						name: "创建时间",
						prop: "createTime",
						type: ""
					},
				],
				tableData: [],
				docclinicMap: {},
				restaurants: [],
				// ★ 角色树专属 props：label 字段显示 roleName，实际存的是 label 字段
				roleTreeProps: {
					children: 'children',
					label: 'label'
				},
				// add
				addForm: {
					username: '',
					status: '1',
					roleId: [],           // ★ 字符串数组，与后端 string id 对应
					clinicId: '',
					staffName: '',
					staffId: '',
					password: '123456',
					email: '',
				},
				// edit
				editForm: {
					username: '',
					userId: 0,
					email: '',
					roleId: [],           // ★ 字符串数组，与后端 string id 对应
					status: '',
					clinicId: 0,
				},
				resetPwdForm: {
					userId: null,
					oldPassword: '',
					newPassword: '',
				},
				rules: {
					username: [{
							required: true,
							message: "请输入账户名",
							trigger: "blur"
						},
						{
							min: 2,
							max: 8,
							message: "长度在2到8个字符",
							trigger: "blur"
						}
					],
					password: [{
							required: true,
							message: "请输入密码",
							trigger: "blur"
						},
						{
							min: 6,
							max: 12,
							message: "当前密码安全性低！",
							trigger: "blur"
						},
					],
				}
			}
		},
		mounted() {
			// 获取数据源
			this.loadData();
			this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
			this.userName = this.userInfo.username;
			this.loginUserId = this.userInfo.userId;

			// 预加载诊所选项
			this.chooseclinicId();

			// 获取动态盒子宽度
			this.$nextTick(() => {
				this.updateWindowWidth();
				window.addEventListener('resize', this.updateWindowWidth);
			});

			this.initButtons();

			// ========== 权限调试信息 ==========
			this.$nextTick(() => {
				console.log('=== 权限调试信息 ===');
				console.log('当前用户权限列表:', this.$store.state.permissions);
				console.log('hasPermission("system:user:edit"):', this.$store.getters.hasPermission('system:user:edit'));
				console.log('hasPermission("system:user:editPwd"):', this.$store.getters.hasPermission('system:user:editPwd'));
				if (typeof this.$store.getters.hasPermission !== 'function') {
					console.error('错误：store 中没有定义 hasPermission getter！');
				}
			});
		},
		watch: {
			// ★ 角色选项变化时，同步刷新两棵树的勾选
			roleoptions: {
				handler(newOptions) {
					if (newOptions && newOptions.length > 0) {
						this.$nextTick(() => {
							this.setAddRoleTreeChecked();
							this.setEditRoleTreeChecked();
						});
					}
				},
				deep: true
			},

			// ★ 编辑弹窗打开时，确保树勾选同步
			editModelDialogVisible: {
				handler(visible) {
					if (visible) {
						this.$nextTick(() => {
							setTimeout(() => this.setEditRoleTreeChecked(), 100);
						});
					}
				}
			}
		},

		methods: {
			initButtons() {
				const currentPath = this.$route.path;
				const routeButtons = this.$getRouteButtons(currentPath);
				this.feetBtn = this.$mergeButtons(this.defaultButtons, routeButtons);
			},

			/*
				数据源
			*/
			async loadData() {
				try {
					let res = await getAllUser({
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						userName: this.searchValue
					});

					if (res.code === 200) {
						this.tableData = (res.data.content || []).map(item => {
							return {
								staffName: item.staffName || '',
								clinicName: item.clinicName || `诊所${item.clinicId || ''}`,
								...item
							};
						});

						this.totalSize = res.data.totalSize;

						this.restaurants = this.tableData.map(item => {
							return {
								value: item.username,
								...item
							};
						});

						console.log('数据加载完成，表格数据:', this.tableData);
					}
				} catch (error) {
					console.error('加载数据失败:', error);
					this.$message.error('加载数据失败');
				}
			},

			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				cb(results);
			},

			async getcilinc() {
				let res = await docclinic();
				this.docclinicOptions = res.data.map(v => {
					return {
						label: v.name,
						...v
					}
				});
				this.docclinicMap = this.docclinicOptions.reduce((map, item) => {
					map[item.id] = item.label;
					return map;
				}, {
					1: '数据不对，默认null'
				});
			},

			createFilter(queryString) {
				return (restaurant) => {
					return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},

			async handleUserSearch() {
				if (!this.currentTable || !this.currentTable.userId) {
					this.$message({
						type: 'warning',
						message: '请先选择一条用户数据'
					});
					return;
				}

				try {
					this.loading = true;
					const res = await GetUserInfo({
						userid: this.currentTable.userId
					});
					if (res.code === 200) {
						this.userForm = {
							username: res.data.username || '',
							staffName: res.data.staffName,
							staffId: res.data.staffId,
							country: res.data.country || 'CN',
							phone: res.data.phone || '',
							email: res.data.email || '',
							uid: res.data.userId || '',
							clinicId: res.data.clinicId,
							mustChangePassword: res.data.mustChangePassword || false,
							sendNotification: false
						};
						this.searchDialogVisible = true;
						this.editForm.clinicId = res.data.clinicId;
					} else {
						this.$message.error(res.message || '获取用户信息失败');
					}
				} catch (error) {
					console.error('获取用户信息失败:', error);
					this.$message.error('获取用户信息失败');
				} finally {
					this.loading = false;
				}
			},

			handleSelect(item) {
				this.loading = true;
				setTimeout(() => {
					this.tableData = [];
					this.tableData.push(item);
					this.loading = false;
				}, 1500);
			},

			handleCurrentTableChange(val) {
				this.currentTable = val;
				if (val) {
					this.$notify({
						title: '成功',
						message: this.currentTable.username + '已选择',
						type: 'success'
					});
				}
			},

			async chooseStaff() {
				let res = await yglist();
				this.Useroptions = res.data;
				this.Useroptions = this.Useroptions.map(v => {
					return {
						label: v.fullName,
						...v
					};
				});
			},

			/**
			 * ★★★ 加载角色列表 ★★★
			 * 后端 roleList.id 已是 string 类型，这里只做 String 归一化，绝不做 Number 转换。
			 * 同时兼容 res 为数组或 {data: []} 两种结构。
			 */
			async chooserole() {
				try {
					const clinicId = this.editForm.clinicId || this.userInfo.clinicId || 1;
					console.log('加载角色选项，诊所ID:', clinicId);

					let res = await roleList({
						clinicId: clinicId,
						pageNum: 1,
						pageSize: 100
					});

					console.log('角色接口返回数据:', res);

					if (res) {
						// 兼容：res 直接是数组 / res.data 是数组
						let roleData = Array.isArray(res) ? res : (res.data || []);

						// ★ id 强制 String，label 使用 roleName（字段名以 el-tree 的 props.label 为准）
						this.roleoptions = roleData.map(item => {
							const roleId = String(item.id || item.roleId || item.value || '').trim();
							const roleName = item.roleName || item.name || item.label || `角色${roleId}`;
							return {
								...item,
								id: roleId,
								label: roleName,
								value: roleId
							};
						});

						console.log('最终角色选项（id 全为 string）:', this.roleoptions);

						// 加载完成后刷新两棵树的勾选
						this.$nextTick(() => {
							this.setAddRoleTreeChecked();
							this.setEditRoleTreeChecked();
						});

						return this.roleoptions;
					}
				} catch (error) {
					console.error('加载角色选项失败:', error);
					this.$message.error('加载角色选项失败');
					this.roleoptions = [];
					return [];
				}
			},

			async chooseclinicId() {
				this.clinicIdoptions = await doccliniclist();
				this.clinicIdoptions = this.clinicIdoptions.data.map(v => {
					return {
						label: v.name,
						...v
					};
				});
			},

			showDetail(row) {
				this.detailData = { ...row };
				this.detailDialogVisible = true;
			},

			async getClinicName(clinicId) {
				if (!clinicId) return '';
				try {
					if (this.clinicIdoptions && this.clinicIdoptions.length > 0) {
						const clinic = this.clinicIdoptions.find(item => item.id === clinicId);
						return clinic ? clinic.label : `诊所${clinicId}`;
					}
					const res = await doccliniclist();
					if (res.code === 200) {
						this.clinicIdoptions = res.data.map(item => ({
							label: item.name,
							id: item.id,
							...item
						}));
						const clinic = this.clinicIdoptions.find(item => item.id === clinicId);
						return clinic ? clinic.label : `诊所${clinicId}`;
					}
					return `诊所${clinicId}`;
				} catch (error) {
					console.error('获取诊所名称失败:', error);
					return `诊所${clinicId}`;
				}
			},

			async feetHandClick(v) {
				if (v.title == '用户新增' || v.title.includes('新增')) {
					this.$message({
						type: 'warning',
						message: '本系统用户为自生成!'
					});
				} else if (v.title === '修改用户' || v.title.includes('修改')) {
					if (this.currentTable) {
						this.chooserole();
						this.editModelDialogVisible = true;
						let res = await getuserInfo({
							userid: this.currentTable.userId
						});
						this.editForm = {
							...res.data
						};
					} else {
						this.$message({
							type: 'warning',
							message: '请先选择一条数据'
						});
					}
				} else if (v.title === '删除' || v.title.includes('删除')) {
					this.$message({
						type: 'success',
						message: '系统用户不能被删除!'
					});
				} else if (v.title === '查询' || v.title.includes('查询')) {
					this.handleUserSearch();
				} else if (v.title === '查看' || v.title.includes('查看')) {
					if (this.currentTable) {
						this.detailData = { ...this.currentTable };
						this.detailDialogVisible = true;
					} else {
						this.$message({
							type: 'warning',
							message: '请先选择一条数据'
						});
					}
				} else if (v.title === '导入' || v.title.includes('导入')) {
					this.$confirm('敬请期待')
						.then(_ => {})
						.catch(_ => {});
				} else if (v.title === '修改密码' || v.title.includes('修改密码')) {
					if (this.currentTable) {
						this.resetPwdForm.userId = this.currentTable.userId;
						this.Self = (this.loginUserId === this.currentTable.userId);
						this.resetPwdForm.oldPassword = '';
						this.resetPwdForm.newPassword = '';
						this.resetPwddialogVisible = true;
					} else {
						this.$message({
							type: 'warning',
							message: '请先选择一条数据'
						});
					}
				} else if (v.title === '打印' || v.title.includes('打印')) {
					this.handlePrint();
				} else if (v.title === '关闭' || v.title.includes('关闭')) {
					setTimeout(() => {
						window.history.back();
					}, 888);
				} else {
					this.$message({
						type: 'error',
						message: '操作失败,请联系管理员！'
					});
				}
			},

			resetForm() {
				this.$refs.addForm.resetFields();
				this.addModelDialogVisible = false;
			},

			/**
			 * ★ 新增提交：提交前从树同步最新勾选（字符串数组）
			 */
			async submitForm() {
				this.$refs.addForm.validate(async (valid) => {
					if (valid) {
						if (this.$refs.addRoleTree) {
							const keys = this.$refs.addRoleTree.getCheckedKeys();
							this.addForm.roleId = keys.map(k => String(k));
						}

						let rs = await addUser(this.addForm);
						if (rs.code === 200) {
							this.$message({
								message: rs.message,
								type: "success"
							});
							this.loadData();
							this.addModelDialogVisible = false;
						} else {
							this.$message({
								type: "info",
								message: rs.message
							});
						}
					}
				});
			},

			handlePrint() {
				this.$confirm('请选择打印方式', '打印设置', {
					confirmButtonText: 'Lodop打印',
					cancelButtonText: '浏览器打印',
					type: 'warning'
				}).then(() => {
					console.log('用户选择Lodop打印');
					this.printWithLodop();
				}).catch(() => {
					console.log('用户选择浏览器打印');
					this.$message({
						type: 'warning',
						message: '浏览器打印出错,正在跳转lodop打印！'
					});
					this.loading = true;
					setTimeout(() => {
						this.printWithLodop();
						this.loading = false;
					}, 1888);
				});
			},

			xtRest() {
				if (!this.resetPwdForm.userId) {
					this.$message.error('未选择用户，请重新打开重置密码窗口');
					return;
				}

				this.$confirm("执行此操作系统将重置到最初始的系统密码(123456), 是否确认继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						const params = {
							userId: this.resetPwdForm.userId,
							newPassword: '123456'
						};
						let res = await editPwd(params);
						if (res.code === 200) {
							if (this.Self === true) {
								this.$message({
									type: "success",
									message: '当前账户的密码已修改，请重新登录！'
								});
								localStorage.clear();
								this.$router.push('/login');
							} else {
								this.$message({
									type: 'success',
									message: '密码已重置为 123456！'
								});
								this.loadData();
								this.resetPwddialogVisible = false;
							}
						} else {
							this.$message.error(res.message || '重置失败');
						}
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消"
						});
					});
			},

			printWithLodop() {
				const tableData = this.tableData.map(item => {
					return {
						...item
					};
				});

				this.$router.push({
					path: '/PrintTemplateDesigner',
					query: {
						tableData: JSON.stringify(tableData),
						currentTable: JSON.stringify(tableData),
						templateName: this.nameTitle
					}
				});
			},

			async toggleStatus(row) {
				let res = await getuserInfo({
					userid: row.userId
				});
				this.editForm = {
					...res.data
				};
				try {
					const newStatus = row.status === '1' ? '0' : '1';
					this.editForm.status = row.status;
					const res = await updateUser(this.editForm);
					if (res.code === 200) {
						row.status = newStatus;
						this.$message({
							type: 'success',
							message: `状态已${newStatus === '1' ? '启用' : '禁用'}`
						});
						this.loading = false;
					} else {
						this.$message.error(res.message || '状态更新失败');
						this.loading = false;
					}
				} catch (error) {
					console.error('状态更新失败:', error);
					this.$message.error('状态更新失败');
				} finally {
					this.loading = false;
				}
			},

			ChangeStatus(val) {},

			async handleUserSuspendAccount(row) {
				try {
					await this.$confirm('确定要禁用该用户吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});

					const res = await userSuspendAccount(row.userId);
					if (res.code !== 200) {
						this.$message.error(res.message || '操作失败');
						return;
					}
					this.loadData();
				} catch (error) {
					if (error !== 'cancel') {
						console.error('禁用用户异常:', error);
						this.$message.error('网络错误，请稍后重试');
					}
				}
			},

			/**
			 * ★★★ 打开编辑模态框 ★★★
			 * - 先拉取详情，roleId 统一转「字符串数组」（不做 Number 转换）
			 * - 再加载角色选项，最后打开对话框，@opened 会触发回填
			 */
			async handleClickEdit(row) {
				try {
					console.log('开始打开编辑模态框，行数据:', row);

					let res = await getuserInfo({
						userid: row.userId
					});

					if (res.code === 200) {
						this.editForm = {
							...res.data
						};

						this.editForm.staffName = res.data.staffName || row.staffName || '';
						this.editForm.clinicName = res.data.clinicName || row.clinicName || '';

						// ★ roleId 统一转「字符串数组」
						let rawRoleIds = [];
						if (res.data.roleId) {
							if (Array.isArray(res.data.roleId)) rawRoleIds = res.data.roleId;
							else if (typeof res.data.roleId === 'string' && res.data.roleId.trim()) rawRoleIds = res.data.roleId.split(',');
							else rawRoleIds = [res.data.roleId];
						}
						this.editForm.roleId = rawRoleIds
							.map(r => String(r).trim())
							.filter(Boolean);

						console.log('处理后的角色ID（String 数组）:', this.editForm.roleId);

						// 先加载角色选项，再打开对话框
						await this.chooserole();
						this.editModelDialogVisible = true;
					} else {
						this.$message.error(res.message || '获取用户信息失败');
					}
				} catch (error) {
					console.error('打开编辑模态框失败:', error);
					this.$message.error('获取用户信息失败');
				}
			},

			/**
			 * ★★★ 提交修改 ★★★
			 * roleId 提交「原始字符串数组」，不做任何 Number 转换
			 */
			async editSubmit() {
				try {
					// 提交前从树里再同步一次
					if (this.$refs.editRoleTree) {
						const keys = this.$refs.editRoleTree.getCheckedKeys();
						this.editForm.roleId = keys.map(k => String(k));
					}

					let roleIds = [];
					if (Array.isArray(this.editForm.roleId)) {
						roleIds = this.editForm.roleId.map(id => String(id).trim()).filter(Boolean);
					} else if (this.editForm.roleId) {
						roleIds = [String(this.editForm.roleId).trim()].filter(Boolean);
					}

					const submitData = {
						userId: this.editForm.userId,
						username: this.editForm.username,
						email: this.editForm.email,
						roleId: roleIds,
						status: this.editForm.status,
						clinicId: this.editForm.clinicId
					};

					console.log('提交的数据:', submitData);

					let res = await updateUser(submitData);

					if (res.code === 200) {
						this.$message({
							type: 'success',
							message: '修改成功'
						});
						this.loadData();
						this.editModelDialogVisible = false;
					} else {
						this.$message.error(res.message || '修改失败');
					}
				} catch (error) {
					console.error('修改用户失败:', error);
					this.$message.error('修改失败');
				}
			},

			HandleCommand(row, cmd) {
				if (row && row.userId) {
					this.resetPwdForm.userId = row.userId;
					this.Self = (this.loginUserId === row.userId);
					this.resetPwdForm.oldPassword = '';
					this.resetPwdForm.newPassword = '';
					this.resetPwddialogVisible = true;
				} else {
					this.$message.error('无效的用户数据，请重试');
				}
			},

			async resetPwdSubmit() {
				if (!this.resetPwdForm.userId) {
					this.$message.error('用户ID丢失，请重新打开窗口操作');
					return;
				}

				let res = await editPwd(this.resetPwdForm);
				if (res.code === 200) {
					if (this.Self === true) {
						this.$message({
							type: "success",
							message: '当前账户的密码已修改，请重新登录！'
						});
						localStorage.clear();
						this.$router.push('/login');
					} else {
						this.$message({
							type: 'success',
							message: '密码已重置！'
						});
						this.loadData();
						this.resetPwddialogVisible = false;
					}
				} else {
					this.$message.error(res.message || '重置失败');
				}
			},

			/* ============ 角色树相关方法（核心） ============ */

			/**
			 * ★ 新增弹窗：树勾选变化 → form.roleId（字符串数组）
			 */
			handleAddRoleTreeCheck() {
				if (!this.$refs.addRoleTree) return;
				const keys = this.$refs.addRoleTree.getCheckedKeys();
				this.addForm.roleId = keys.map(k => String(k));
			},

			/**
			 * ★ 编辑弹窗：树勾选变化 → form.roleId（字符串数组）
			 */
			handleEditRoleTreeCheck() {
				if (!this.$refs.editRoleTree) return;
				const keys = this.$refs.editRoleTree.getCheckedKeys();
				this.editForm.roleId = keys.map(k => String(k));
			},

			/**
			 * ★ 新增弹窗：回填勾选（form.roleId 全部 String 化）
			 */
			setAddRoleTreeChecked() {
				if (!this.$refs.addRoleTree) return;
				const keys = Array.isArray(this.addForm.roleId)
					? this.addForm.roleId.map(k => String(k)).filter(Boolean)
					: [];
				this.$refs.addRoleTree.setCheckedKeys(keys);
			},

			/**
			 * ★ 编辑弹窗：回填勾选（form.roleId 全部 String 化）
			 */
			setEditRoleTreeChecked() {
				if (!this.$refs.editRoleTree) return;
				const keys = Array.isArray(this.editForm.roleId)
					? this.editForm.roleId.map(k => String(k)).filter(Boolean)
					: [];
				console.log('[setEditRoleTreeChecked] 回填 keys:', keys);
				this.$refs.editRoleTree.setCheckedKeys(keys);
			},

			/**
			 * ★ 新增弹窗打开后回调：DOM 渲染完成 → 回填
			 */
			onAddDialogOpened() {
				this.$nextTick(() => {
					this.setAddRoleTreeChecked();
				});
			},

			/**
			 * ★ 编辑弹窗打开后回调：DOM 渲染完成 → 回填
			 */
			onEditDialogOpened() {
				this.$nextTick(() => {
					this.setEditRoleTreeChecked();
				});
			},

			/*
				about tree
			*/
			handleNodeClick(data, e) {
				this.CatalogueName = data.title;
				this.iconComes = 'el-icon-' + this.makePy(data.label);
			},
			PwdRules(val) {},

			choosedRole(val) {
				this.addForm.staffId = val;
				let vrs = this.Useroptions.find(v => v.id === val);
				if (vrs) this.addForm.staffName = vrs.fullName;
			},

			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},

			handleClose(done) {
				this.formdisabled = true;
				done();
			},

			handClick(i) {
				switch (i) {
					case 0:
						this.loading = true;
						setTimeout(() => {
							this.loadData();
							this.loading = false;
						}, 800);
						break;
				}
			},

			headerBtnbottomRightClick(i) {
				switch (i) {
					case 0:
						this.$message({
							type: "info",
							message: "暂不支持,请联系工作人员!"
						});
						break;
					case 1:
						this.loading = true;
						setTimeout(() => {
							this.loadData();
							this.$message({
								type: 'success',
								message: '已重置'
							});
							this.loading = false;
						}, 1500);
						break;
				}
			},

			columnWidth(col, list) {
				let prop = col.prop,
					lab = col.lab;
				let width = 40;
				let maxlenStr = "";
				for (let info of list) {
					if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
				}
				width = Math.max(width, len(lab), len(maxlenStr));
				return width + 12;

				function len(str) {
					let length = 8;
					for (const char of str + "") {
						if ("a" <= char && char <= "z") length += 12;
						else if ("A" <= char && char <= "Z") length += 8;
						else if (Number.isFinite(Number(char))) length += 8;
						else if (char >= "\u4e00" && char <= "\u9fa5") length += 18;
						else length += 12;
					}
					return length;
				}
			},

			handledbRow(row, column, event) {},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageSize = val;
				this.pageNum = 1;
				this.loadData();
			},

			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNum = val;
				this.loadData();
			},

			updateWindowWidth() {
				this.windowWidth = window.innerWidth - 368;
			},
		},
	}
</script>

<style lang="less" scoped>
	// 穿透
	/deep/ .el-select-dropdown__list {
		max-height: 300px;
		overflow-y: auto;
		margin-top: -6px;
	}

	/deep/ .el-dialog__header {
		padding: 12px;
		background-color: #007bb0;
	}

	/deep/ .el-dialog__body {
		margin-top: -20px;
	}

	/deep/ .el-dialog__title {
		font-size: 12px;
		color: #fff;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	}

	/deep/ .el-dropdown {
		font-size: 12px;
		cursor: pointer;
	}

	/deep/ .el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	/deep/ .demonstration {
		display: block;
		color: #8492a6;
		font-size: 14px;
		margin-bottom: 20px;
	}

	/* ========== 角色树样式 ========== */
	.role-tree-wrapper {
		width: 178px;
		max-height: 180px;
		overflow-y: auto;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		padding: 4px 2px;
		background: #fff;

		.role-tree {
			background: transparent;

			/deep/ .el-tree-node__content {
				height: 26px;
				line-height: 26px;
				border-radius: 3px;

				&:hover {
					background-color: #f5f7fa;
				}
			}

			/deep/ .el-checkbox__inner {
				width: 14px;
				height: 14px;
			}

			/deep/ .el-tree-node__label {
				font-size: 12px;
				color: #606266;
			}

			/deep/ .el-tree-node.is-checked>.el-tree-node__content {
				background-color: #f0f9ff;

				.el-tree-node__label {
					color: #409eff;
					font-weight: 500;
				}
			}
		}
	}

	.user {
		width: 100%;
		height: 100%;
		background-color: #fff;
		padding: 4px;

		.title {
			height: 40px;
			line-height: 40px;

			span {
				font-weight: 300;
				margin-left: 12px;
			}
		}

		.main {
			width: 100%;
			margin-top: 8px;
			display: flex;

			.main-left {
				flex: 1;

				.tree {
					margin-top: 8px;
				}

				/deep/ .tree .el-tree-node {
					position: relative;
				}

				/deep/ .tree .el-tree-node :last-child:before {
					height: 38px;
				}

				/deep/ .tree .el-tree>.el-tree-node:before {
					border-left: none;
				}

				.tree-container .el-tree>.el-tree-node:after {
					border-top: none;
				}

				/deep/ .tree .el-tree-node__children .el-tree-node:before {
					content: '';
					left: 12px;
					position: absolute;
					right: auto;
					border-width: 1px;
				}

				/deep/ .tree .el-tree-node__children {
					padding-left: 0px;
				}

				/deep/ .tree .el-tree-node:after {
					content: '';
					left: 12px;
					position: absolute;
					right: auto;
					border-width: 1px;
				}

				/deep/ .tree .el-tree-node__expand-icon.is-leaf {
					display: none;
				}

				/deep/ .tree .el-tree-node:before {
					border-left: 1px dashed #dddddd;
					bottom: 0px;
					height: 100%;
					top: -26px;
					width: 1px;
				}

				/deep/ .tree .el-tree-node:after {
					border-top: 1px dashed #dddddd;
					height: 20px;
					top: 12px;
					width: 24px;
				}
			}

			.main-right {
				flex: 6;
				margin-left: 12px;

				.searchValue {
					display: flex;

					/deep/ .el-input {
						width: 188px;
					}

					/deep/ .el-select {
						margin-left: 8px;
					}

					/deep/ .el-button {
						margin-left: 8px;
					}
				}

				.btnBottom {
					display: flex;
					justify-content: space-between;
					margin-top: 18px;
				}

				.content {
					display: flex;
					justify-content: center;
					width: 100%;
					margin-top: 12px;
					border: 1px solid #dddddd;
					border-radius: 4px;

					/deep/ .el-table .cell {
						font-size: 12px;
						text-overflow: ellipsis;
						white-space: nowrap;
						overflow: hidden;
					}

					/deep/ .el-table {
						width: 100%;
					}

					/deep/ td {
						padding: 0 !important;
						height: 32px;
					}

					/deep/ .el-table td.el-table__cell div :first-child {
						text-align: center;
					}
				}
			}
		}
	}
</style>